import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://xbjfpbegulqxwfyhfacg.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhiamZwYmVndWxxeHdmeWhmYWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIyMDU3MzIsImV4cCI6MjA5Nzc4MTczMn0.6YqN6GZg5qQ16tpP7jDpo03Y3JOeKYQMdLf_WfdRwHY";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
